export const environment = {
  production: false,
  apiUrl: "https://dswd-api-dev.getpass.ph/"
};
